<template>
    <div>
        <b-modal
                ref="modal-devedor-nao-encontrado"
                id="modal-devedor-nao-encontrado"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="CPF/CNPJ Não Encontrado"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">O devedor não está cadastrado. Deseja cadastra-lo?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <div class="mx-auto justify-content-center text-center">
                    <b-button variant="outline-primary" @click="abrirModalDevedor" class="mr-2"> <i class="fas fa-user"></i> Cadastrar Devedor</b-button>
                    <b-button variant="outline-secondary" @click="cancelarModalDevedor"> <i class="fa fa-times"></i> Fechar</b-button>
                </div>
            </template>
        </b-modal>
        <b-modal
                ref="modal-devedor-cadastro"
                id="modal-devedor-cadastro"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="modalTitulo"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal !== null">
                        <b-alert show variant="danger">{{ messageModal }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group
                                        label="CPF / CNPJ:"
                                        label-for="cpf"
                                        class="text-label required">
                                    <b-form-input
                                            type="text"
                                            id="num-documento"
                                            data-vv-as="CPF"
                                            v-model="contribuinte.documento"
                                            v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                                            description="Somente os números"
                                            :disabled="inclusaoDireta"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2" md="5">
                                <b-form-group
                                        label="Nome:"
                                        label-for="nome"
                                        class="text-label required">
                                    <b-form-input v-model="contribuinte.nome" type="text" id="nome" maxlength="100"
                                                  @keyup="contribuinte.nome = (contribuinte.documento && contribuinte.documento.replace(/[^a-zA-Z0-9]/g, '').length > 11 ? removeSpecialCharactersNumero(contribuinte.nome) : removeSpecialCharacters(contribuinte.nome))"
                                                  :class="'text-label required ' + (!paymentValidations.nome.valid ? 'is-invalid' : '')"
                                    />
                                    
                                    <b-row>
                                    <b-col sm="12" md="12">
                                    <div v-if="!paymentValidations.nome.valid" class="invalid-message">Campo Obrigatório.</div>
                                   </b-col>
                                   </b-row> 
                                   
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card title="Endereço">
                        <b-row>
                            <b-col sm="2" md="3">
                                <b-form-group
                                        label="CEP:"
                                        label-for="cep"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="cep"
                                            data-vv-as="cep"
                                            v-model="contribuinte.cep"
                                            v-mask="['#####-###']"
                                            description="Somente os números"
                                            @change="obterEnderecoPorCep()"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2" md="5">
                                <b-form-group
                                        label="Logradouro:"
                                        label-for="logradouro"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.logradouro" type="text" id="logradouro" maxlength="100"
                                                  @keyup="contribuinte.logradouro = removeSpecialCharactersGeral(contribuinte.logradouro)"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="2">
                                <b-form-group
                                        label="Número:"
                                        label-for="numero"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.numero" type="text" id="numero" maxlength="100"
                                                  @keyup="contribuinte.numero = removeSpecialCharactersNumero(contribuinte.numero)"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group
                                        label="Complemento:"
                                        label-for="complemento"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.complemento" type="text" id="complemento" maxlength="50"
                                                  @keyup="contribuinte.complemento = removeSpecialCharactersGeral(contribuinte.complemento)"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-form-group
                                        label="Bairro:"
                                        label-for="bairro"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.bairro" type="text" id="bairro" maxlength="50"
                                                  @keyup="contribuinte.bairro = removeSpecialCharactersGeral(contribuinte.bairro)"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group label="UF:" label-for="uf" class="text-label">
                                    <multiselect
                                            class="multiselect-simple"
                                            name="uf"
                                            v-model="contribuinte.uf"
                                            :show-labels="false"
                                            :options="dados.uf"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            placeholder="Selecione"
                                            track-by="nome"
                                            label="nome"
                                            @input="listarMunicipios()">
                                        <template v-slot:first>
                                            <option :value="null">Selecionar</option>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-form-group label="Município:" label-for="municipio" class="text-label">
                                    <multiselect
                                            class="multiselect-simple"
                                            name="municipio"
                                            v-model="contribuinte.municipio"
                                            :show-labels="false"
                                            :options="dados.municipios"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            placeholder="Selecione"
                                            track-by="codMunicipio"
                                            label="nome"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card title="Contato">
                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Telefone/Celular:"
                                        label-for="telefone"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="telefone"
                                            data-vv-as="telefone"
                                            v-model="contribuinte.telefone"
                                            v-mask="['(##) #####-####', '(##) ####-####']"
                                            description="Somente os números"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Telefone Alternativo 1:"
                                        label-for="telefoneAlternativo1"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="telefoneAlternativo1"
                                            data-vv-as="telefoneAlternativo1"
                                            v-model="contribuinte.telefoneAlternativo1"
                                            v-mask="['(##) #####-####', '(##) ####-####']"
                                            description="Somente os números"
                                            @change="permitirSalvar = true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Telefone Alternativo 2:"
                                        label-for="telefoneAlternativo2"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="telefoneAlternativo2"
                                            data-vv-as="telefoneAlternativo2"
                                            v-model="contribuinte.telefoneAlternativo2"
                                            v-mask="['(##) #####-####', '(##) ####-####']"
                                            description="Somente os números"
                                            @change="permitirSalvar = true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="E-mail principal:"
                                        label-for="email"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.email" type="text" id="email" maxlength="100" ref="email"
                                                  @keyup="contribuinte.email = removeSpecialCharactersGeral(contribuinte.email)"
                                                  :class="!validations.email.valid ? 'is-invalid' : ''"/>
                                    <div v-if="!validations.email.valid" class="invalid-message">E-mail inválido!</div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="E-mail alternativo 1:"
                                        label-for="emailAlternativo1"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.emailAlternativo1" type="text" id="emailAlternativo1" maxlength="100" ref="emailAlternativo1"
                                                  @keyup="contribuinte.emailAlternativo1 = removeSpecialCharactersGeral(contribuinte.emailAlternativo1)"
                                                  :class="!validations.emailAlternativo1.valid ? 'is-invalid' : ''"/>
                                    <div v-if="!validations.emailAlternativo1.valid" class="invalid-message">E-mail inválido!</div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="E-mail alternativo 2:"
                                        label-for="emailAlternativo2"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.emailAlternativo2" type="text" id="emailAlternativo2" maxlength="100" ref="emailAlternativo2"
                                                  @keyup="contribuinte.emailAlternativo2 = removeSpecialCharactersGeral(contribuinte.emailAlternativo2)"
                                                  :class="!validations.emailAlternativo2.valid ? 'is-invalid' : ''"/>
                                    <div v-if="!validations.emailAlternativo2.valid" class="invalid-message">E-mail inválido!</div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="cancelarModalDevedor"> <i class="fa fa-times"></i> Cancelar</b-button>
                <b-button variant="primary" @click="validarSalvar" class="mr-2"> <i class="far fa-save"></i> Salvar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')"> Não</b-button>
                <b-button variant="primary" @click="salvarDevedor"> Sim</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "./CompLoading";

    export default {
        mixins: [ formatarMixins ],
        components: {CompLoading},
        data() {
            return {
                urlApi: null,
                token: null,
                documento: null,
                inclusaoDireta: false,
                dados: {
                    uf: [],
                    municipios: []
                },
                contribuinte: {
                    nome: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    emailAlternativo1: null,
                    emailAlternativo2: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: null,
                    municipio: null
                },
                messageModal: null,
                modalTitulo: 'CPF/CNPJ Não Encontrado',
                validations: {
                    email: { valid: true },
                    emailAlternativo1: { valid: true },
                    emailAlternativo2: { valid: true }
                },
                
                 paymentValidations: {
                    nome: { valid: true, message: ""}
                    
                    
                }, 
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            abrirModalIncluirDevedor() {
                this.messageModal = null;
                this.inclusaoDireta = false;
                this.$refs['modal-devedor-nao-encontrado'].show();
            },
            abrirModalIncluirDevedorCpf(cpf) {
                this.messageModal = null;
                this.inclusaoDireta = false;
                this.documento = cpf;
                this.$refs['modal-devedor-nao-encontrado'].show();
            },
            abrirModalIncluirDevedorComDados(devedor) {
                this.inclusaoDireta = true;
                this.contribuinte = {
                    ...devedor
                };
                this.messageModal = null;
                this.$refs['modal-devedor-nao-encontrado'].hide();
                this.$refs['modal-devedor-cadastro'].show();
            },
            abrirModalDevedor (opts) {
                this.inclusaoDireta = false;
                this.contribuinte = {
                    nome: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    emailAlternativo1: null,
                    emailAlternativo2: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: null,
                    municipio: null
                };
                this.contribuinte.documento = this.documento;

                this.modalTitulo = ((opts) && (opts.modalTitulo)) ? opts.modalTitulo : 'CPF/CNPJ Não Encontrado';

                this.$refs['modal-devedor-nao-encontrado'].hide();
                this.$refs['modal-devedor-cadastro'].show();
            },
            cancelarModalDevedor() {
                this.limparValidations(this.paymentValidations);
                this.$refs['modal-devedor-nao-encontrado'].hide();
                this.$refs['modal-devedor-cadastro'].hide();
                this.$emit('cancelarNovoDevedor');
            },
            async listarUfs() {
                axios.get(`${this.urlApi}/v1/endereco/listarUf`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.uf = response.data;
                })
            },
            async listarMunicipios() {
                this.contribuinte.municipio = null;
                if(this.contribuinte.uf == null) {
                    this.dados.municipios = [];
                } else {
                    axios.get(`${this.urlApi}/v1/endereco/listarMunicipios/${this.contribuinte.uf.nome}`, {
                        headers: {
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.dados.municipios = response.data;
                    })
                }
            },
            obterEnderecoPorCep() {
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/endereco/obterEnderecoPorCep/${this.contribuinte.cep}`, '', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.contribuinte.uf = null;
                    for(var i = 0; i < this.dados.uf.length; i++) {
                        if(this.dados.uf[i].nome == response.data.uf) {
                            this.contribuinte.uf = this.dados.uf[i];
                        }
                    }

                    this.listarMunicipios();

                    this.contribuinte.municipio = response.data.cidade;
                    this.contribuinte.logradouro = response.data.logradouro;
                    this.contribuinte.bairro = response.data.bairro;
                    this.contribuinte.complemento = response.data.complemento;
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
            validarSalvar() {
                this.messageModal = null;
               
                if(this.contribuinte.documento.length <= 14 && !this.validarCpf(this.contribuinte.documento)) {
                    this.messageModal = 'CPF inválido.';
                    return;
                } else if(this.contribuinte.documento.length > 14 && !this.validarCnpjAlfanumerico(this.contribuinte.documento)) {
                    this.messageModal = 'CNPJ inválido.';
                    return;
                }

                if(!this.validateEmail(this.contribuinte.email, this.validations.email)
                    | !this.validarValorObrigatorio(this.contribuinte.nome)
                    | !this.validateEmail(this.contribuinte.emailAlternativo1, this.validations.emailAlternativo1)
                    | !this.validateEmail(this.contribuinte.emailAlternativo2, this.validations.emailAlternativo2)) {
                    return;
                }

                if(this.inclusaoDireta) {
                    this.salvarDevedor();
                } else {
                    this.$refs['modal-salvar'].show();
                }
            },
            
            validarValorObrigatorio() {
                
                if(this.contribuinte.nome == "" | this.contribuinte.nome == null) {
                    this.validarCampoObrigatorio(this.contribuinte.nome, this.paymentValidations.nome)
                    return this.paymentValidations.nome.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.nome.valid=true;
                    
                }
  
            },
            
            
            limparValidacao() {
            
               this.limparValidations(this.paymentValidations);
            },
            
            salvarDevedor() {
                this.$refs['modal-salvar'].hide();

                let devedorBusca = {
                    documento: this.contribuinte.documento
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedorBusca, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        this.messageModal = 'CPF/CNPJ já cadastrado no sistema.';
                        window.scrollTo(0,0);
                        this.$refs.loading.hideLoading();
                    } else {
                        this.$refs['modal-devedor-cadastro'].hide();
                        axios.post(`${this.urlApi}/v1/contribuinte/salvarModal`, this.contribuinte, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': this.token
                            }
                        }).then(response => {
                            if(response.data.documento.toString().length <= 11) {
                                response.data.documento = this.mascaraCpf(response.data.documento);
                            } else {
                                response.data.documento = this.mascaraCnpj(response.data.documento);
                            }

                            this.$emit('novoDevedor', response.data);
                        }).catch((error) => {
                            this.exibirErro(error)
                        }).finally(() => {
                            this.$refs.loading.hideLoading();
                        });
                    }
                }).catch((error) => {
                    this.exibirErro(error);
                    this.$refs.loading.hideLoading();
                });
            },
            verificarObrigatoriedade() {
                return !(this.verificarValorVazio(this.contribuinte.nome) ||
                    this.verificarValorVazio(this.contribuinte.documento));
            },
            validarSalvarEnter(e) {
                setTimeout(()=>{
                    if(this.$refs['modal-devedor-cadastro'].isShow && e.key == 'Enter' && this.$refs['modal-salvar'] != undefined) {
                        this.validarSalvar();
                    }
                }, 200);
            },
            isShow() {
                return this.$refs['modal-devedor-cadastro'].isShow;
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.listarUfs();
            setTimeout(()=>{
                window.addEventListener("keypress", this.validarSalvarEnter);
            }, 500);
        }
    }
</script>
<style scoped>
</style>
